import type {MaybeRef} from 'vue';

export const spaceKey = 'space';

export function spaceStructureQueryKey(
    userId: MaybeRef<string | null>,
    effectiveBookingForId: MaybeRef<string | null>
) {
    return [spaceKey, 'structure', userId, effectiveBookingForId] as const;
}

export function characteristicsQueryKey(locationId: MaybeRef<string | null>) {
    return [spaceKey, 'characteristics', locationId] as const;
}

export function adminLocationsQueryKey(accountId: MaybeRef<string | null>) {
    return [spaceKey, 'adminLocations', accountId] as const;
}

export function floorRoomsQueryKey(floorId: string) {
    return [spaceKey, 'floorRooms', floorId] as const;
}

export function adminFloorQueryKey(locationId: string, floorId: string) {
    return [spaceKey, 'adminFloor', locationId, floorId] as const;
}
